import MyPage from '../../../Commons/Layouts/MyPage';
import Container from './Container';

const CouponHistory = (props) => {
  return (
    <MyPage>
      <Container {...props} />
    </MyPage>
  );
};

export default CouponHistory;
